module.exports = __webpack_public_path__ + "img/W-7.61acd365.jpg";